import React, { useRef } from "react";
import Downshift from "downshift";
import {
  FormControl,
  FormHelperText,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  ListItem,
  ListItemText,
  MenuList,
  Paper,
  Popper
} from "@material-ui/core";
import { ArrowDropUp, ArrowDropDown, Clear } from "@material-ui/icons";
import { MarkHighlighter } from "@components";

export type TextAutosuggestProps = {
  value: string;
  label?: string;
  error?: boolean;
  options: LabelValue[];
  helperText?: string;
  onChange: (val: string) => void;
};
export default function FormAutosuggest(props: TextAutosuggestProps) {
  const { value = "", label, helperText, options, onChange, error } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  function getInputWidth() {
    return inputRef.current
      ? inputRef.current.parentElement.getBoundingClientRect().width
      : 200;
  }
  const iconStyle = { style: { fontSize: 16 } };
  return (
    <>
      <Downshift
        itemToString={(i) => (i ? i.value : "")}
        selectedItem={{ value }}
        onStateChange={(changes) => {
          // eslint-disable-next-line no-prototype-builtins
          if (changes.hasOwnProperty("selectedItem")) {
            onChange(changes.selectedItem ? changes.selectedItem.value : "");
            // eslint-disable-next-line no-prototype-builtins
          } else if (changes.hasOwnProperty("inputValue")) {
            onChange(changes.inputValue);
          }
        }}
      >
        {({
          getLabelProps,
          getInputProps,
          getToggleButtonProps,
          getMenuProps,
          getItemProps,
          isOpen,
          clearSelection,
          selectedItem,
          inputValue,
          highlightedIndex
        }) => (
          <div>
            <FormControl error={error} fullWidth>
              <InputLabel>{label}</InputLabel>
              <Input
                inputRef={inputRef}
                endAdornment={
                  <InputAdornment position="end">
                    {value && (
                      <IconButton
                        onClick={() => clearSelection()}
                        aria-label="Clear selection"
                        style={{ padding: 0 }}
                      >
                        <Clear {...iconStyle} />
                      </IconButton>
                    )}

                    <IconButton
                      aria-label="Toggle menu open"
                      style={{ padding: 5 }}
                      {...getToggleButtonProps()}
                    >
                      {isOpen ? (
                        <ArrowDropUp {...iconStyle} />
                      ) : (
                        <ArrowDropDown {...iconStyle} />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                {...getInputProps()}
                value={value}
              />
              {helperText && <FormHelperText>{helperText}</FormHelperText>}
            </FormControl>

            <Popper
              open={isOpen}
              anchorEl={inputRef.current}
              placement="bottom-start"
              style={{ zIndex: 9999 }}
              modifiers={{
                preventOverflow: { enabled: false },
                hide: { enabled: false }
              }}
            >
              <Paper
                {...getMenuProps({})}
                style={{
                  maxHeight: 200,
                  overflowY: "auto",
                  minWidth: getInputWidth()
                }}
              >
                <MenuList>
                  {options
                    .filter((x) => x.label.toLowerCase().includes(value.toLowerCase()))
                    .map((item, index) => (
                      <ListItem
                        key={item.value}
                        button
                        {...getItemProps({
                          index,
                          item,
                          key: item.value,
                          isSelected: selectedItem === item,
                          style: {
                            backgroundColor:
                              highlightedIndex === index ? "lightgray" : "white",
                            fontWeight: selectedItem === item ? "bold" : "normal"
                          }
                        })}
                      >
                        <ListItemText primary={item.label} className="hl" />
                      </ListItem>
                    ))}
                </MenuList>
              </Paper>
            </Popper>
          </div>
        )}
      </Downshift>

      <MarkHighlighter
        highlightSearch={value}
        getMarkjsContext={() => document.querySelectorAll(".hl")}
      />
    </>
  );
}
